<app-header [forceLightBackground]="true"></app-header>
<div class="provider-access-requests">
  <div class="flex min-h-screen w-full flex-col lg:flex-row">
    <div class="provider-access-requests--sidebar-col">
      <app-provider-sidebar></app-provider-sidebar>
    </div>
    <div class="provider-access-requests--content flex-1 min-w-0">
      <app-page-header></app-page-header>
      <app-asset-request (reloadData)="loadProviderAssetRequests()"></app-asset-request>
    </div>
  </div>
</div>
